import {
  CLOSE_ICVC_MODAL,
  GET_ICVC_POLICIES_START,
  GET_ICVC_POLICIES_SUCCESS,
  GET_ICVC_POLICIES_ERROR,
} from './types';
import { createAction, getActionList } from './action-utils';
import { ICVCRequest, ICVCResponse } from 'ts/types/icvc.types';

const actions = {
  closeIcvcModal: () => createAction(CLOSE_ICVC_MODAL, {}),
  getPolicies: (body: ICVCRequest) =>
    createAction(GET_ICVC_POLICIES_START, body),
  getPoliciesSuccess: (payload: ICVCResponse) =>
    createAction(GET_ICVC_POLICIES_SUCCESS, payload),
  getPoliciesError: (payload: any) =>
    createAction(GET_ICVC_POLICIES_ERROR, payload),
};

export default actions;

const actionList = getActionList(actions);

export type ICVCActionType = typeof actionList[number];
